import * as actionTypes from './actionTypes';

export const setProductNotionalPooling = data => ({
  type: actionTypes.SAVE_DATA_NOTIONAL_POOLING,
  data
})

export const deletePool = data => ({
  type: actionTypes.NOTIONAL_POOLING_DELETEPOOL,
  data
})

export const setStatus = statuses => ({
  type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_STATUSES,
  statuses
})


export const setPartyCurrency = currency => ({
  type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_PARTY_CURRENCY,
  currency
})

export const setFormDataInterestOptimization = dataIO => ({
  type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_INTEREST_OPTIMIZATION_DATA,
  dataIO
})

export const setBasicDetailAcc = accounts => ({
  type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_BD_ACCOUNTS,
  accounts
})

export const setPageJson = par => ({
  type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON,
  par
})

export function setPageJson1(par) {
   return {
     type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_1,
     par
   }
}

export const setPoolIdAfterSaveReferesh = poolId =>({
     type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_POOL_ID,
     poolId
})
export const resetPoolIdAfterSaveReferesh = () =>({
     type: actionTypes.RESET_CURRENT_NOTIONAL_POOLING_POOL_ID
})

export function setPageJson2(par) {
   return {
     type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_2,
     par
   }
}


export const setPageJsonAccordian = par => ({
  type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_ACCODRIAN,
  par
})

export const interestPeriodSettlementDate = date => ({
  type: actionTypes.SET_CURRENT_NOTIONAL_POOLING_INTEREST_PERIOD_SETTLEMENT_DATE,
  date
})

export const updatedAccountInfo = (data, id) => ({
  type: actionTypes.UPDATE_ACCOUNT_INFO,
  data,
  id
})

export const setStandAloneAccounts = account => ({
  type: actionTypes.SET_STATND_ALONE_ACCOUNTS,
  account
})

export const setNewPoolActiveTabIndex = index => ({
  type: actionTypes.SET_NEW_POOL_ACTIVE_TAB_INDEX,
  index
})

export const reSetNewPoolActiveTabIndex = () => ({
  type: actionTypes.RESET_NEW_POOL_ACTIVE_TAB_INDEX
})



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/actions/actionCreator.js